<template>
    <div>
        <div class="c_pub_button_confirm" @click="testStart">测试</div>
        <input v-model="testcount" type="number" />
        <div>测试: {{ count }}/ {{testcount}}</div>
        <div v-for="(item, index) in string" :key="index">{{ index+1 }}： {{item}}</div>
    </div>
</template>

<script>
import { string } from "html-docx-js/dist/html-docx";
import { v4 as uuidv4 } from "uuid";

export default {
    data() {
        return {
            count: 0,
            testcount: 10,
            string: []
        }
    },
    methods: {
        test() {
            let params = {
                "assistant_id": "6063369f-289a-11ef-8bf4-12e77c4cb76b",
                "message": [
                    {
                        "type": "text",
                        "text": "NOTICE Role: 你是一名教师，你正在使用一个在线学习平台来教授学生，你已经完成了教案，你现在需要将教案变为学生上课用的任务单（work sheet）。该在线学习平台为每个任务提供了资源区（视频，ppt，阅读资料将放在这里），多种互动工具（学生点击工具即可上传他们的作业或者回答，这些互动工具类似kahoot一样允许教师轻松收集，统计，追踪学生作业），以及和任务绑定的目标和评价系统。 Language: Chinese. ATTENTION: Use '##' to SPLIT SECTIONS, not '#'. Output format carefully referenced \"Format example\". Instruction: Based on the context, follow \"Format example\", write content.  # Context ## 要求 请根据<教学任务教案> 和 #范例 为该教学任务输出学生任务单中的任务描述。你的主要任务是输出任务描述，用亲切的口吻告诉学生他们需要做什么。你的输出需要符合# 输出格式与要求     ## 参考资料 教学任务教案：根据提供的任务描述和课程简要描述，我将为“探索与形成成果：项目小组合作与研究报告撰写”设计详细的教案。以下是教案的详细内容： 教学目标1. 通过小组合作，学生能够完成关于中华优秀传统文化的研究报告。2. 学生能够展示语文学习中的收获，并表达对文化自信的理解。3. 学生能够在报告中清晰展示研究过程和结果，体现综合运用能力和创新思维。 教学过程| 教师活动 | 学生活动 ||||| 1. 引入课题：教师介绍本次任务的背景和目标，强调中华优秀传统文化的重要性。 | 学生听讲，了解任务背景，思考自己对中华文化的理解。 || 2. 组织分组：教师将学生分成若干小组，并分配各组的研究主题。 | 学生根据教师的分组进行小组讨论，明确各自的研究主题。 || 3. 指导研究方法：教师讲解如何查找资料、分析问题、撰写报告的方法。 | 学生学习并记录研究方法，提出自己的疑问。 || 4. 资料收集：教师指导学生利用图书馆、互联网等资源进行资料收集。 | 学生在小组内分工合作，收集与主题相关的资料。 || 5. 撰写报告：教师提供报告撰写的模板和注意事项。 | 学生根据模板撰写研究报告，互相交流意见。 || 6. 反馈与修订：教师对各小组的初稿进行点评，提出修改建议。 | 学生根据教师的反馈进行报告的修订和完善。 || 7. 展示与评价：教师组织学生进行报告展示，并进行评价。 | 学生展示研究成果，接受教师和同学的评价。 | 评价量规 学生能够在报告中清晰展示研究过程和结果。 学生能够体现出综合运用能力和创新思维。 学生能够自信地展示和讲解研究成果，清晰传达核心观点。 相关知识点讲解 中华优秀传统文化的核心思想理念。 研究报告的基本结构和撰写技巧。 小组合作的有效策略和沟通技巧。通过以上教学过程，学生将能够在小组合作中提升对中华文化的理解和表达能力，增强文化自信，并在实践中锻炼综合运用能力和创新思维。  # 输出格式与要求 任务描述（告诉学生他们需要做什么）： 任务描述：从教案中提取并且改写，改写为教师给与学生的指示（用于指导学生如何进行该教学活动），对应到学生活动，你应该用友好，但是又清晰明确的口吻来撰写。内容至少200个token，你需要详细的描述该任务该如何做）。  # 范例 亲爱的同学们，今天我们将一起探索热是如何在不同的环境中传递的。 我们将通过一系列有趣的实验来观察热在水中的传递过程。请大家准备好实验材料，并确保遵循安全指南。我们将使用感温粉末或红墨水来帮助我们直观地看到热是如何在水中移动的。 在实验过程中，请大家仔细观察并记录你的发现，我们将一起讨论热对流是如何形成的。 不要忘记，实验后我们要分享我们的观察结果，并探讨热对流在我们生活中的应用。让我们一起揭开热传递的神秘面纱吧！  # Format example { \"detail\":\"任务描述\" }"
                    }
                ],
                "session_name": uuidv4(),
                "userId": "5943e08c-b7d4-11ed-8d51-005056b86db5",
                "file_ids": [
                    "file-1H00vPDJC3ecxVwJ95jAbweG",
                    "file-W4idJ411RBRrMVpVvwKShF0g",
                    "file-OTTHGOJS7BEZgqWIUKX1LLDE",
                    "file-oTBOO9kISmtZf5KaTi10VU4T"
                ],
                "model": "gpt-4o-2024-11-20",
                "temperature": 0.1
            }
            let _this = this
            this.ajax
                .post("https://gpt4.cocorobo.cn/ai_agent_park_chat", params)
                .then(async (response) => {
                    console.log(response);
                    let data = response.data.FunctionResponse
                    console.log(data);
                    _this.string.push(data.message)
                    _this.count++
                }).catch((error) => {
                    console.log(error);

                });
        },
        testStart(){
            this.count = 0
            for (let index = 0; index < parseInt(this.testcount); index++) {
                this.test()                
            }
        },
    },
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/pages/testAi.vue